import { Button } from '@jouzen/ecom-components/v3/Button';
import { Modal } from '@jouzen/ecom-components/v4/Modal';
import { useGateValue } from '@statsig/react-bindings';
import { useTranslations } from 'next-intl';
import { useState } from 'react';

import Video from '@/app/components/Video/Video';

const CeramicVideoModal = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const t = useTranslations();
  const isVideoEnabled = useGateValue('ceramic_care_hero_video');

  if (!isVideoEnabled) return null;

  return (
    <Modal
      onOpenChange={setIsOpen}
      triggerButton={(props) => (
        <Button variant="secondary-light" {...props}>
          {t('watch_the_video')}
        </Button>
      )}
      variant="extra-large"
    >
      {({ titleProps }) => (
        <div className="px-6 md:px-12">
          <div className="aspect-video">
            {/* @TODO: Place the video and poster */}
            <Video
              className="size-full"
              contentTitle="or4_ceramic_video_title"
              id={titleProps.id}
              location="sizing-hero"
              localizedSrc="sizing_gen4_sizing_video_src"
              playVideo={isOpen}
              preload="metadata"
              type="video/mp4"
              posterSrc="sizing/video-poster.png"
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default CeramicVideoModal;
